module.exports = __webpack_public_path__ + "officialStatic/img/detail.ed9f220.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/solution/detail.png
// module id = eM8B
// module chunks = 0